module.exports = __webpack_public_path__ + "img/screenshot_board_3_super_pos_collapsed.6fa34b90.png";